export default __webpack_public_path__ + "static/media/KaneAbel.2f69daa8.mp4";